import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../core/services/auth.service';
import { FormValidationService } from '../../../core/services/form-validation.service';
import { Store } from '@ngrx/store';
import { ActivatedRoute, Router } from '@angular/router';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { ToastService } from '../../../core/services/toast.service';
import { ApiError } from '../../../core/models/common/api-error';
import { authActions } from 'angular/app/core/store/auth';
import { RoomPermission } from '../../../core/models/entities/permission';

@Component({
  selector: 'app-password-reset-page',
  template: `
    <app-auth-template title="Réinitialiser mot de passe">
      <form novalidate (ngSubmit)="submit()">
        <app-text-input
          [control]="form.get('email')"
          name="email"
          inputmode="email"
          [disabled]="true"
          label="<i class='fal fa-lg fa-paper-plane mr-1.5'></i> Adresse e-mail"
        ></app-text-input>
        <app-password-input
          [control]="form.get('password')"
          name="password"
          label="<i class='fal fa-lg fa-lock mr-1.5'></i> Mot de passe"
          placeholder="Introduire un nouveau mot de passe"
        ></app-password-input>
        <div class="flex justify-center pt-4 md:pt-8">
          <app-button data-cy="submit" type="submit" [loading]="sendingData"
            >Réinitialiser</app-button
          >
        </div>
      </form>
    </app-auth-template>
  `,
  standalone: false,
})
export class PasswordResetPageComponent implements OnInit {
  form: UntypedFormGroup;
  sendingData: boolean;
  constructor(
    private authService: AuthService,
    private formValidationService: FormValidationService,
    private router: Router,
    private store: Store,
    private toastService: ToastService,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {
    const { email, token } = this.route.snapshot.queryParams;
    this.form = new UntypedFormGroup({
      email: new UntypedFormControl(email),
      password: new UntypedFormControl('', [Validators.required]),
      token: new UntypedFormControl(token),
    });
  }

  async submit() {
    if (this.formValidationService.validate(this.form)) {
      try {
        this.sendingData = true;
        const response = await this.authService.resetPassword({
          ...this.form.value,
          password_confirmation: this.form.value.password,
        });
        this.store.dispatch(authActions.loginSuccess(response));
        if (
          !response.user.vendor.has_rooms &&
          response.user.all_permissions.includes(RoomPermission.Store)
        ) {
          await this.router.navigate(['/salles']);
        } else {
          await this.router.navigate(['/reservations']);
        }

        this.toastService.success(
          'Votre mot de passe a été réinitialisé avec succès.',
        );
      } catch (exception) {
        this.toastService.error((exception as ApiError).message);
      }
      this.sendingData = false;
    }
  }
}
